import axios from "axios";
import { BASE_URL, DOMAIN } from "./apiConfig";

export const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-domain-name": DOMAIN,
  },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["x-domain-name"] = DOMAIN;
  return config;
});
